<script setup lang="ts">
import IFrameLayout from "./IFrameLayout.vue";
import MainLayout from "./MainLayout.vue";

const isMain = window.self === window.top;
</script>

<template>
  <div class="min-h-screen flex flex-col justify-center items-center">
    <component :is="isMain ? MainLayout : IFrameLayout">
      <slot />
    </component>
  </div>
</template>
